module.exports = __webpack_public_path__ + "assets/school.f5155db0.svg";